import { useState } from 'react';

import Image from 'next/image';

import { RegisterMethods } from '@/features/v2/auth/register/RegisterMethods';

import LoadingSpinner from '@/components/common/LoadingSpinner';

import Footer from './Footer';
import { core } from './localization/core';

const Registerlayout = ({ view }: { view: string }) => {
  const subtitle = view === 'casino' ? core.subtitleCasino : core.subtitleSport;
  const prize = view === 'casino' ? '/img/v2/register/spins.webp' : '/img/v2/register/L100.webp';
  const [googlePending, setGooglePending] = useState(false);

  return (
    <main
      className="min-h-screen bg-cover bg-center relative"
      style={{ backgroundImage: view === 'casino' ? 'url(/img/v2/register/flatbgCasino.webp)' : 'url(/img/v2/register/sportBg.webp)' }}
    >
      <div className="h-full">
        {googlePending && <LoadingSpinner />}
        <div className="flex flex-col items-center justify-center relative pt-5">
          <h1 className="text-white text-3xl font-bold text-center z-50">{core.title}</h1>

          <div className="flex items-center gap-2 mt-4">
            {view === 'casino' && <div className="w-24 h-1 bg-white rounded-full" />}
            <p className={view === 'casino' ? 'text-sivarbet-primary text-base font-medium' : 'text-white font-medium text-lg'}>{subtitle}</p>
            {view === 'casino' && <div className="w-24 h-1 bg-white rounded-full" />}
          </div>

          <Image
            src={prize}
            alt="Premio"
            width={70}
            height={70}
            className="absolute bottom-[-19px] right-9 z-50 animationPulse"
          />
        </div>
        <RegisterMethods welcomeBonus={view} onGooglePendingChange={setGooglePending} />
      </div>
      <Footer />
    </main>
  );
};

export default Registerlayout;
